<template>
  <tooltip class="app-tooltip"
           v-bind="props"
           v-on="handlers">
  </tooltip>
</template>

<script>
// Elements
import Tooltip from './Tooltip.vue'

// Libraries
import { mapState } from 'vuex'

export default {
  name: 'app-tooltip',

  components: {
    Tooltip
  },

  computed: {
    ...mapState('appElement', ['props', 'handlers'])
  }
}
</script>
